import { DKIcons, DKButton, DKLabel, DKTooltipWrapper } from 'deskera-ui-library';
import { getCurrencySymbolFromCode, toCurrencyFormat } from './Helper';
import { getDateStrFromDate, getDueDateInfoForGrid } from './Date';
import { DATE_FORMATS } from '../constants/Enum';
import store from '../store';

/**
 * Renders a due date in red with a tooltip ("3 days overdue", "Due Today"),
 * unless the document is already settled, in which case the date is plain.
 * @param statusKey - row key holding the status, value can be a string or a single item array
 * @param settledStatus - status for which the due date needs no highlight
 */
export const dueDateRenderer =
  ({ statusKey, settledStatus }) =>
  ({ value, rowData }) => {
    const dueDate = value instanceof Date ? value : new Date(value);
    if (!value || isNaN(dueDate.getTime())) {
      return <></>;
    }

    const dateFormat =
      store.getState().books?.tenantDetails?.dateFormat ||
      DATE_FORMATS['DD-MM-YYYY'];
    const dateText = getDateStrFromDate(dueDate, dateFormat);

    const status = Array.isArray(rowData?.[statusKey])
      ? rowData[statusKey][0]
      : rowData?.[statusKey];
    if (status === settledStatus) {
      return <DKLabel text={dateText} className="fs-m" />;
    }

    const dueDateInfo = getDueDateInfoForGrid(dueDate);
    return (
      <DKTooltipWrapper
        content={dueDateInfo.text}
        tooltipClassName="bg-deskera-secondary width-auto"
      >
        <DKLabel text={dateText} className={dueDateInfo.class} />
      </DKTooltipWrapper>
    );
  };

export const amountRenderer = ({ rowData }, columnKey) => {
  const currencyCode = getCurrencySymbolFromCode(rowData?.currency);
  return (
    <div className="row justify-content-end">
      {toCurrencyFormat(rowData[columnKey] || 0, currencyCode)}
    </div>
  );
};

export const attachmentRenderer = ({ rowData }, onView) => {
  if (rowData?.attachmentsWithLink?.length) {
    return (
      <div className="row">
        <DKButton
          title="View"
          icon={DKIcons.ic_attachment}
          className="p-v-0"
          onClick={onView}
        />
      </div>
    );
  } else {
    return <></>;
  }
};
